import { useAtomValue } from 'jotai';
import { $CurrentAvailableArticleOrNull } from '@article/shared/atoms/current-article';
import { $CurrentArticleTranslated } from '@article/shared/atoms/current-article-translated';

export const useArticleKeywords = (): string[] => {
  const article = useAtomValue($CurrentAvailableArticleOrNull);
  const articleTranslated = useAtomValue($CurrentArticleTranslated);

  if (!article) {
    return [];
  }

  const result: string[] = [];
  const { relatedQueryInfos } = article;

  const articleTitle = article.title;
  if (articleTitle) {
    result.push(articleTitle);
  }

  result.push(article.author.nickName);
  result.push(...relatedQueryInfos.map((info) => info.word));
  result.push('Lemon8');

  return result;
};
